import {Dominio, type IDominioConfig, type ISubdominioCompleto} from "services-comun/modules/net/config/dominio";
import {immute} from "services-comun/modules/utiles/object";

export type TSite = "ar"|"at"|"bo"|"br"|"ca"|"cl"|"cr"|"de"|"do"|"ec"|"en"|"es"|"eu"|"fr"|"hn"|"it"|"mx"|"nl"|"pa"|"pe"|"pt"|"py"|"ru"|"uy"|"ve";
export type TPlataforma = "web"|"android"|"ios"|"harmony";
export type DominioTiempoList = [DominioTiempo, ...DominioTiempo[]];

export interface IDominioTiempoConfig extends IDominioConfig {
    id: TSite;
    pais: number;
    idiomas: string[];
}

export class DominioTiempo extends Dominio {
    /* STATIC */
    public static readonly SERVICES: ISubdominioCompleto = immute({
        nombre: "services",
        scheme: "https",
    });

    public static readonly ar = immute(new this({ dominio: "meteored.com.ar",   id: "ar", pais: 67,  idiomas: ["es-AR"], }));
    public static readonly at = immute(new this({ dominio: "daswetter.at",      id: "at", pais: 164, idiomas: ["de-AT"], }));
    public static readonly bo = immute(new this({ dominio: "meteored.com.bo",   id: "bo", pais: 176, idiomas: ["es-BO"], }));
    public static readonly br = immute(new this({ dominio: "tempo.com",         id: "br", pais: 82,  idiomas: ["pt-BR"], }));
    public static readonly ca = immute(new this({ dominio: "theweather.net",    id: "ca", pais: 165, idiomas: ["en-CA"], }));
    public static readonly cl = immute(new this({ dominio: "meteored.cl",       id: "cl", pais: 196, idiomas: ["es-CL"], }));
    public static readonly cr = immute(new this({ dominio: "meteored.cr",       id: "cr", pais: 114, idiomas: ["es-CR"], }));
    public static readonly de = immute(new this({ dominio: "daswetter.com",     id: "de", pais: 19,  idiomas: ["de-DE"], }));
    public static readonly do = immute(new this({ dominio: "meteored.do",       id: "do", pais: 97,  idiomas: ["es-DO"], }));
    public static readonly ec = immute(new this({ dominio: "meteored.com.ec",   id: "ec", pais: 115, idiomas: ["es-EC"], }));
    public static readonly en = immute(new this({ dominio: "yourweather.co.uk", id: "en", pais: 48,  idiomas: ["en-GB"], }));
    public static readonly es = immute(new this({ dominio: "tiempo.com",        id: "es", pais: 18,  idiomas: ["es-ES"], }));
    public static readonly eu = immute(new this({ dominio: "theweather.com",    id: "eu", pais: 58,  idiomas: ["en-EU"], }));
    public static readonly fr = immute(new this({ dominio: "tameteo.com",       id: "fr", pais: 135, idiomas: ["fr-FR"], }));
    public static readonly hn = immute(new this({ dominio: "meteored.hn",       id: "hn", pais: 166, idiomas: ["es-HN"], }));
    public static readonly it = immute(new this({ dominio: "ilmeteo.net",       id: "it", pais: 20,  idiomas: ["it-IT"], }));
    public static readonly mx = immute(new this({ dominio: "meteored.mx",       id: "mx", pais: 155, idiomas: ["es-MX"], }));
    public static readonly nl = immute(new this({ dominio: "tameteo.nl",        id: "nl", pais: 21,  idiomas: ["nl-NL"], }));
    public static readonly pa = immute(new this({ dominio: "meteored.com.pa",   id: "pa", pais: 143, idiomas: ["es-PA"], }));
    public static readonly pe = immute(new this({ dominio: "meteored.pe",       id: "pe", pais: 139, idiomas: ["es-PE"], }));
    public static readonly pt = immute(new this({ dominio: "tempo.pt",          id: "pt", pais: 182, idiomas: ["pt-PT"], }));
    public static readonly py = immute(new this({ dominio: "meteored.com.py",   id: "py", pais: 73,  idiomas: ["es-PY"], }));
    public static readonly ru = immute(new this({ dominio: "pogoda.com",        id: "ru", pais: 122, idiomas: ["ru-RU"], }));
    public static readonly uy = immute(new this({ dominio: "meteored.com.uy",   id: "uy", pais: 154, idiomas: ["es-UY"], }));
    public static readonly ve = immute(new this({ dominio: "meteored.com.ve",   id: "ve", pais: 151, idiomas: ["es-VE"], }));

    protected static readonly IDS: Record<TSite, DominioTiempo> = immute({
        "ar": this.ar,
        "at": this.at,
        "bo": this.bo,
        "br": this.br,
        "ca": this.ca,
        "cl": this.cl,
        "cr": this.cr,
        "de": this.de,
        "do": this.do,
        "ec": this.ec,
        "en": this.en,
        "es": this.es,
        "eu": this.eu,
        "fr": this.fr,
        "hn": this.hn,
        "it": this.it,
        "mx": this.mx,
        "nl": this.nl,
        "pa": this.pa,
        "pe": this.pe,
        "pt": this.pt,
        "py": this.py,
        "ru": this.ru,
        "uy": this.uy,
        "ve": this.ve,
    });
    public static ALL_SITES: DominioTiempo[] = immute([this.ar, this.at, this.bo, this.br, this.ca, this.cl, this.cr, this.de, this.do, this.ec, this.en, this.es, this.eu, this.fr, this.hn, this.it, this.mx, this.nl, this.pa, this.pe, this.pt, this.py, this.ru, this.uy, this.ve,]);
    private static readonly PAISES: Record<number, DominioTiempo> = immute({
        18: this.es,
        19: this.de,
        20: this.it,
        21: this.nl,
        48: this.en,
        58: this.eu,
        67: this.ar,
        73: this.py,
        82: this.br,
        97: this.do,
        114: this.cr,
        115: this.ec,
        122: this.ru,
        135: this.fr,
        139: this.pe,
        143: this.pa,
        151: this.ve,
        154: this.uy,
        155: this.mx,
        164: this.at,
        165: this.ca,
        166: this.hn,
        176: this.bo,
        182: this.pt,
        196: this.cl,
    });
    private static readonly IDIOMAS: Record<string, DominioTiempoList> = immute({
        "de":    [this.de, this.at],
        "de-AT": [this.at],
        "de-DE": [this.de],
        "en":    [this.eu, this.en, this.ca],
        "en-CA": [this.ca],
        "en-GB": [this.en],
        "en-EU": [this.eu],
        "es":    [this.es, this.ar, this.mx, this.bo, this.cl, this.cr, this.do, this.ec, this.hn, this.pa, this.pe, this.py, this.uy, this.ve],
        "es-AR": [this.ar],
        "es-BO": [this.bo],
        "es-CL": [this.cl],
        "es-CR": [this.cr],
        "es-DO": [this.do],
        "es-EC": [this.ec],
        "es-ES": [this.es],
        "es-HN": [this.hn],
        "es-MX": [this.mx],
        "es-PA": [this.pa],
        "es-PE": [this.pe],
        "es-PY": [this.py],
        "es-UY": [this.uy],
        "es-VE": [this.ve],
        "fr":    [this.fr],
        "fr-FR": [this.fr],
        "it":    [this.it],
        "it-IT": [this.it],
        "nl":    [this.nl],
        "nl-NL": [this.nl],
        "pt":    [this.pt, this.br],
        "pt-BR": [this.br],
        "pt-PT": [this.pt],
        "ru":    [this.ru],
        "ru-RU": [this.ru],
    });

    public static getID(id: TSite): DominioTiempo {
        return this.IDS[id];
    }

    public static getPais(id: number): DominioTiempo {
        return this.PAISES[id]??this.IDS["eu"];
    }

    public static getIdioma(id: string): DominioTiempoList {
        return this.IDIOMAS[id]??[this.IDS["eu"]];
    }

    public static search(dominio: string, subdominio: ISubdominioCompleto): DominioTiempo|undefined {
        return this.ALL_SITES.find(site=>site.host(subdominio.nombre)==dominio || site.host(site.BASE)==dominio);
    }

    /* INSTANCE */
    protected readonly SUBDOMINIO_SERVICES = DominioTiempo.SERVICES;

    public readonly SERVICES = this.SUBDOMINIO_SERVICES.nombre;

    public readonly id: TSite;
    public readonly idioma: string;
    public readonly idioma_corto: string;
    public readonly idiomas: string[];
    public readonly pais: number;

    protected constructor(config: IDominioTiempoConfig) {
        const listado = [DominioTiempo.SERVICES];
        super({...config,
            subdominios: {
                listado,
                habilitados: listado.map(actual=>actual.nombre),
                redirigidos: [],
            },
        });

        this.id = config.id;
        this.idioma = config.idiomas[0];
        this.idioma_corto = this.idioma.substring(0, 2);
        this.idiomas = config.idiomas;
        this.pais = config.pais;
    }
}

export {DominioTiempo as Dominio};

const tiempo = DominioTiempo;
export default tiempo;
